// Copyright (c) 2016 Deere & Company

import KeyValuePair, {getDefaultState as getKeyValuePairDefaultState} from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import t from 'tcomb';

const Countries = t.list(KeyValuePair, 'Countries');

export const getDefaultState = () => [getKeyValuePairDefaultState()];

export default Countries;



// WEBPACK FOOTER //
// ./src/product/status-change-request/state/countries.js